import { jsx } from "react/jsx-runtime";
import "../store/createAppApi.js";
import "../store/createAppAsyncThunk.js";
import "../store/createAppSelector.js";
import "../store/createAppSlice.js";
import "react";
import "redux";
import "../store/hooks/useAppDispatch.js";
import { useAppSelector } from "../store/hooks/useAppSelector.js";
import "../store/hooks/useAppStore.js";
const DEFAULT_SELECTOR = (_state) => ({
  enable: true
});
function withEnabledComponent(Component, selector = DEFAULT_SELECTOR) {
  function EnabledComponent(props) {
    var _a;
    const isShow = (_a = useAppSelector(selector)) == null ? void 0 : _a.enable;
    if (!isShow) {
      return null;
    }
    return /* @__PURE__ */ jsx(Component, { ...props });
  }
  EnabledComponent.displayName = `withEnabledComponent(${Component.displayName || Component.name})`;
  return EnabledComponent;
}
export {
  withEnabledComponent
};
